// Persistencia de "visto" del changelog. El proyecto no tiene ningún
// mecanismo genérico de preferencias por usuario en Firebase, así que se
// usa localStorage con try/catch (modo incógnito, cuota llena, etc. no
// deben tumbar la vista — simplemente no se recuerda nada en esos casos).

const KEY_VISTOS = "dashport_changelog_vistos";
const KEY_ULTIMA_BIENVENIDA = "dashport_changelog_ultima_bienvenida_id";

function leerJSON(key, valorDefault) {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return valorDefault;
    return JSON.parse(raw);
  } catch (e) {
    return valorDefault;
  }
}

function escribirJSON(key, valor) {
  try {
    window.localStorage.setItem(key, JSON.stringify(valor));
  } catch (e) {
    // localStorage no disponible/lleno: la novedad seguirá mostrándose
    // hasta que expire por fecha, sin romper la interfaz.
  }
}

export function isSeen(id) {
  const vistos = leerJSON(KEY_VISTOS, []);
  return Array.isArray(vistos) && vistos.indexOf(id) !== -1;
}

export function markSeen(id) {
  const vistos = leerJSON(KEY_VISTOS, []);
  if (!Array.isArray(vistos) || vistos.indexOf(id) !== -1) return;
  escribirJSON(KEY_VISTOS, [...vistos, id]);
}

// El modal de bienvenida se identifica por el id de la entrada más
// reciente del changelog en el momento de mostrarse — así, si sale una
// entrada nueva después, vuelve a mostrarse una vez más (una por release).
export function getLastWelcomeShownId() {
  return leerJSON(KEY_ULTIMA_BIENVENIDA, null);
}

export function markWelcomeShown(id) {
  escribirJSON(KEY_ULTIMA_BIENVENIDA, id);
}
